import axios from 'axios';
import { TypeLabel, Format } from '../../../../commentary/commentary.types';

export type GetCommentaryResponse = {
  author: string;
  dateHtml: string;
  format: Format;
  sourceName: string;
  title: string;
  url: string;
} & (
  | { typeLabel: TypeLabel.HYBRID }
  | { typeLabel: TypeLabel.OPEN }
  | { typeLabel: TypeLabel.PAPER }
);

export function getCommentariesLinkedToLegislation(
  docId: string,
  query: string,
): Promise<{ data: Array<GetCommentaryResponse> }> {
  return axios.get('/getCommentariesLinkedToLegislation', {
    params: {
      docId,
      query,
    },
  });
}
